import React, { useEffect, useState } from "react";
import API from "../../services/api.ts";
import MedicalImageItem from "./MedicalImageItem";
import MedicalImageForm from "./MedicalImageForm";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "../navbar/Navbar";

const MedicalImageList = () => {
  const [medicalImages, setMedicalImages] = useState([]);

  const fetchMedicalImages = async () => {
    try {
      const response = await API.get('/images/');
      setMedicalImages(response.data);
    } catch (err) {
      console.error("Error fetching medical images:", err);
      toast.error("Failed to fetch medical images.");
    }
  };

  useEffect(() => {
    fetchMedicalImages();
  }, []);

  return (
    <div>
    <Navbar/>
    <div className="container mt-4">
      <ToastContainer autoClose={3000} />
      <h2 className="text-center mb-4">Medical Image Tracker</h2>
      {/* Form for uploading a new Medical Image */}
      <MedicalImageForm refreshMedicalImages={fetchMedicalImages} />

      {/* Table displaying existing medical images */}
      <table className="table table-striped mt-4">
        <thead className="text-center">
          <tr>
            <th>Patient ID</th>
            <th>Image</th>
            <th>Description</th>
            <th>Uploaded At</th>
            <th>Modality</th>
            <th>Anatomy</th>
            <th>Anonymized</th>
            <th>Synthetic</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody className="text-center">
          {medicalImages.map((medicalImage) => (
            <MedicalImageItem
              key={medicalImage.id}
              medicalImage={medicalImage}
              refreshMedicalImages={fetchMedicalImages}
            />
          ))}
        </tbody>
      </table>
    </div>
    
    </div>
  );
};

export default MedicalImageList;
